import { useState } from 'react'
import {
    getFromLocalStorage,
    removeFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'
import ConfigRepository from '@/shared/config/repository/configRepository'
import { configLsKeyword } from '@/api/apiConstants'
import Config from '@/shared/config/config'
import { useAppStore } from '@/shared/store'

const configRepository = ConfigRepository.Instance

export const useAuthenticationConfig = () => {
    const token = getFromLocalStorage(sessionTokenLsKeyword)
    const [isTokenInStorage, setIsTokenInStorage] = useState(!!token)
    const { setAppSkin } = useAppStore()

    const getAndSaveAppSkinToStore = (config: Config | null | undefined) => {
        if (config) {
            const { skin } = config
            setAppSkin(skin)
        }
    }

    const takeConfigIfNeed = async () => {
        removeFromLocalStorage(configLsKeyword)
        await configRepository.takeConfigIfNeed()
        const config = configRepository.getLocalConfig()
        getAndSaveAppSkinToStore(config)
    }

    const getToken = () => {
        if (token) {
            setIsTokenInStorage(true)
        }
    }
    const authenticateAndFetchConfig = async () => {
        if (!isTokenInStorage) {
            getToken()
        }
        await takeConfigIfNeed()
    }

    return { authenticateAndFetchConfig }
}
